(function ($) {
  if ($(".accordion").length > 0) {
    $(".accordion__accordion.open > .accordion__sub-rows").slideDown();
    $(document).on("click", ".accordion-toggle", function () {
      var accordionToggle = $(this);
      if (accordionToggle.parent(".accordion__accordion").hasClass("accordion__accordion--big")) {
        $(".accordion__accordion--big").not(this).removeClass("open");
        $(".accordion-toggle").next(".accordion__sub-rows").slideUp();
        $(".accordion-toggle").attr("aria-expanded", false);
      }
      accordionToggle.parent(".accordion__accordion").toggleClass("open");
      if (accordionToggle.parent(".accordion__accordion").hasClass("open")) {
        accordionToggle.next(".accordion__sub-rows").slideDown();
        accordionToggle.attr("aria-expanded", true);
      } else {
        accordionToggle.next(".accordion__sub-rows").slideUp();
        accordionToggle.attr("aria-expanded", false);
      }
      vtx.intrinsicRatioVideos.makeFit();
    });
  }
  var hasBeenScrolled = false;
  function animateBigFirstAccordeon(section) {
    if (isElementXPercentInViewport(section, 80) && !hasBeenScrolled) {
      var $firstChild = $(section).find(".accordion:first-child .accordion__accordion--big .accordion-toggle");
      $firstChild.parent(".accordion__accordion").addClass("open");
      $firstChild.next(".accordion__sub-rows").slideDown();
      $firstChild.attr("aria-expanded", true);
      hasBeenScrolled = true;
    }
  }
  document.addEventListener("scroll", function () {
    document.querySelectorAll(".scrollDown .block-accordions-group--big") // only on scroll down
    .forEach(function (bigAccordeonContainer) {
      animateBigFirstAccordeon(bigAccordeonContainer);
    });
  });
})(jQuery); // Fully reference jQuery after this point.